export default ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    let cartElement = '<rp-cart'
    cartElement += ' public-token="' + params.publicToken + '"'
    cartElement += ' locale="' + params.language + '"'
    cartElement += ' primary-main-color="' + params.primaryColor + '"'
    cartElement += ' primary-sub-color="' + params.secondaryColor + '"'
    cartElement += ' secondary-main-color="' + params.primaryColor + '"'
    cartElement += ' secondary-sub-color="' + params.secondaryColor + '"'
    cartElement += ' system="ShopShappy"'
    cartElement += ' shappy-custom-token="' + params.shappyCustomToken + '"'
    cartElement += ' shappy-app-id="' + params.appId + '"'
    cartElement += ' shappy-channel-id="' + params.channelId + '"'
    cartElement += ' firstname="' + params.firstname + '"'
    cartElement += ' lastname="' + params.lastname + '"'
    cartElement += ' email="' + params.email + '"'
    cartElement += ' mobile="' + params.mobile + '"'
    cartElement += ' member="' + params.member + '"'
    cartElement += ' shappy-domain="' + params.domain + '"></rp-cart>'

    resolve(cartElement)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/actions/initCart.js